import { FC, useEffect, useState } from "react";
import styles from "../Scam.module.scss";
import cn from "classnames";
import { useHideDropdown } from "@hooks/useHideDropdown";
import Checkbox from "@components/ui/checkbox";
import { useForm } from "react-hook-form";
import { getScreenSize } from "@utils/getScreenSize";
import Modal from "@components/shared/modals/Modal";
import ModalContent from "@components/shared/modals/Modal/ModalContent";

const FilterButton: FC = () => {
    const [open, setOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { isMobile } = getScreenSize();
    const ref = useHideDropdown<HTMLButtonElement>(setOpen);
    const { register, watch, handleSubmit, setValue } = useForm();

    const formItems = [
        {
            name: "received",
            label: "Received token",
        },
        {
            name: "send",
            label: "Send TON",
        },
        {
            name: "swap",
            label: "Swap tokens",
        },
        {
            name: "nft",
            label: "Received NFT",
        },
    ];

    const handleReset = () => {
        formItems.forEach(({ name }) => {
            setValue(name, false);
        });
    };

    useEffect(() => {
        const subscription = watch(() => handleSubmit((data) => console.log(data))());
        return () => subscription.unsubscribe();
    }, []);

    return (
        <button
            ref={ref}
            onClick={isMobile ? () => setIsModalVisible(!isModalVisible) : () => setOpen(!open)}
            className={styles.filter}
        >
            <span>Filter</span>
            <img width={14} height={14} src="/images/scam/filter.svg" alt="" />
            {isMobile ? (
                <Modal isVisible={isModalVisible} setIsVisible={setIsModalVisible}>
                    <ModalContent classNames={styles.modal}>
                        <div className={styles.modalHeader}>
                            <h2>Filter</h2>
                            <button className={styles.close} onClick={() => setIsModalVisible(false)}>
                                <picture>
                                    <source
                                        srcSet="/images/modal/closemobile.svg"
                                        width={7.5}
                                        height={7.5}
                                        media="(max-width: 768px)"
                                    />
                                    <img
                                        height={12}
                                        width={12}
                                        src="/images/modal/close.svg"
                                        style={{ opacity: 0.4 }}
                                        alt="Close modal"
                                    />
                                </picture>
                            </button>
                        </div>
                        <form
                            onClick={(e) => e.stopPropagation()}
                            className={cn(styles.filterList, {
                                [styles.visible]: isModalVisible,
                                [styles.mobile]: isMobile,
                            })}
                        >
                            {formItems.map(({ label, name }) => (
                                <label key={name} className={styles.filterItem}>
                                    <Checkbox register={register} type="checkbox" id={name} name={name} />
                                    <span>{label}</span>
                                </label>
                            ))}
                            <button onClick={handleReset} className={styles.reset} type="button">
                                <span>Reset Filters </span>
                                <img src="/images/modal/close.svg" alt="" />
                            </button>
                        </form>
                    </ModalContent>
                </Modal>
            ) : (
                <form
                    onClick={(e) => e.stopPropagation()}
                    className={cn(styles.filterList, { [styles.visible]: open })}
                >
                    {formItems.map(({ label, name }) => (
                        <label key={name} className={styles.filterItem}>
                            <Checkbox register={register} type="checkbox" id={name} name={name} />
                            <span>{label}</span>
                        </label>
                    ))}
                </form>
            )}
        </button>
    );
};
export default FilterButton;
